import { ReactNode } from "react";
import { AlertProvider } from "./AlertContext";
import { ConfigurationProvider } from "./ConfigurationContext";
import { LotCountProvider } from "./LotCountContext";
import { PrivilegeProvider } from "./PrivilegeContext";
import { UserPreferencesProvider } from "./UserPreferencesContext";

export function SiteContextProvider({ children }: { children: ReactNode; }) {
    return (
        <ConfigurationProvider>
            <AlertProvider>
                <PrivilegeProvider>
                    <UserPreferencesProvider>
                        <LotCountProvider>
                            {children}
                        </LotCountProvider>
                    </UserPreferencesProvider>
                </PrivilegeProvider>
            </AlertProvider>
        </ConfigurationProvider>
    );
}